import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { resetDocumentThemeOverrides } from './themeReset';
import { isTelegramWebAppEnvironment } from './utils/telegramEnvironment';
import { bootstrapBrowserPwa } from './pwa/bootstrapBrowserPwa';

/** Палитра только из index.css — сброс инлайн-темы Telegram при старте */
resetDocumentThemeOverrides();

if (typeof document !== 'undefined' && !isTelegramWebAppEnvironment()) {
  document.documentElement.classList.add('app-shell-browser');
  bootstrapBrowserPwa();
}

if (isTelegramWebAppEnvironment()) {
  try {
    window.Telegram?.WebApp?.ready();
  } catch (_) {
    /* ignore */
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
